module.exports = __webpack_public_path__ + "static/cosyhome-8cb5f458f1e05051712e65716aa7fea8.jpeg";